import { createFileRoute } from '@tanstack/react-router';
import { TakeExamPage } from '@/features/mockExams/guest/TakeExamPage';
export const Route = createFileRoute('/exam-portal/$registrationId/take')({ component: Page });
function Page() {
  const { registrationId } = Route.useParams();
  return <TakeExamPage key={registrationId} registrationId={registrationId} />;
}
